import { isDefaultVintage } from '@helpers/vintage';

const MEDIAN_TYPE_USER = 'user';
const MEDIAN_TYPE_MARKET = 'market';

export const isMedianTypeMarket = (availability) =>
  availability?.median?.type === MEDIAN_TYPE_MARKET;

export const isMedianTypeUser = (availability) => availability?.median?.type === MEDIAN_TYPE_USER;

export const isSupportedMedianType = (availability) =>
  isMedianTypeMarket(availability) || isMedianTypeUser(availability);

export const getMedianAmount = (availability) => availability?.median?.amount;

export const hasVintageSubstitution = (vintage, availability) => {
  // vintage substitution should happen only on vintage wine pages, not on master wine pages
  if (isDefaultVintage(vintage)) {
    return false;
  }

  const availabilityVintageId = availability?.vintage?.id;
  return !!availabilityVintageId && availabilityVintageId !== vintage.id;
};
